export class TeamEdit
{
    public id = null;
    public user: any = null;
    public role: any = null;
    public member: any = null;
    public subRole: any = null;
    public case: any = null;
    public personId = null;
    public lastName = null;
    public firstName = null;
    public middleName = null;
    public suffix = null;
    public professionalSuffix = null;
    public spokenLanguages = null;
    public gender = null;
    public organization = null;
    public url = '';
    public email = null;
    public taxNo = null;
    public homePhoneNumber = null;
    public homePhoneNumberExtension = null;
    public otherPhoneNumber = null;
    public workPhoneNumber = null;
    public workPhoneNumberExtension = null;
    public cellPhoneNumber = null;
    public faxNumber = null;
    public title = null;
    public npi = null;
    public directAddress = null;
    public directorySource = null;
    public provider: ProviderDetails = null;
    public createAccount = false;
    public accountCreated = false;
    public accountRole: any = null;
    public accountOrganization: any = null;
    public providerDirectorySource: any = null;
    public streetLine = null;
    public streetLineAdditional = null;
    public city = null;
    public county = null;
    public state = null;
    public postalCode = null;
    public country = null;
    public notification = null;
    public identifiers = null;
    public extensions = null;
    public description = null;
    public from: Date;
    public to: Date;
    public longitude: number;
    public latitude: number;
}

export class ProviderDetails
{
    public streetLine = null;
    public streetLineAdditional = null;
    public city = null;
    public county = null;
    public state = null;
    public postalCode = null;
    public country = null;
}

export class Team
{
    public id: number = null;
    public userId = null;
    public roleId = null;
    public memberId = null;
    public roleName = null;
    public userName = null;
    public userFullName = null;
    public subRoleId = null;
    public subRoleName = null;
    public roleTypeId = null;
    public caseId = null;
    public personId = null;
    public lastName = null;
    public firstName = null;
    public middleName = null;
    public suffix = null;
    public professionalSuffix = null;
    public spokenLanguages = null;
    public gender = null;
    public title = null;
    public organization = null;
    public url = '';
    public taxNo = null;
    public homePhoneNumber = null;
    public homePhoneNumberExtension = null;
    public otherPhoneNumber = null;
    public workPhoneNumber = null;
    public workPhoneNumberExtension = null;
    public cellPhoneNumber = null;
    public faxNumber = null;
    public email = null;
    public npi = null;
    public directAddress = null;
    public provider: ProviderDetails = null;
    public createAccount = false;
    public accountCreated = false;
    public accountRole: any = null;
    public accountOrganization: any = null;
    public providerDirectorySource: any = null;
    public streetLine = null;
    public streetLineAdditional = null;
    public city = null;
    public county = null;
    public state = null;
    public postalCode = null;
    public country = null;
    public notification = null;
    public identifiers = null;
    public extensions = null;
    public description = null;
    public from: Date;
    public to: Date;
    public longitude: number;
    public latitude: number;
}

export class TeamRole
{
    public id = null;
    public name = '';
    public description = '';
    public active: boolean;
}

export class TeamAssignEdit
{
    public user: any;
    public member: any;
    public tasks: any;
}
